// eslint-disable-next-line import/no-extraneous-dependencies
import { Analytics } from '@firebase/analytics';
// eslint-disable-next-line import/no-extraneous-dependencies
import { FirebaseApp } from '@firebase/app';
// eslint-disable-next-line import/no-extraneous-dependencies
import { getAnalytics, logEvent } from 'firebase/analytics';
// eslint-disable-next-line import/no-extraneous-dependencies
import { initializeApp } from 'firebase/app';
// @ts-ignore
// eslint-disable-next-line import/no-extraneous-dependencies
import amplitude from 'amplitude-js';
import { isProd } from './utils/general';

export const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: 'vuz-app-production.firebaseapp.com',
  databaseURL: 'https://vuz-app-production.firebaseio.com',
  projectId: 'vuz-app-production',
  storageBucket: 'vuz-app-production.appspot.com',
  messagingSenderId: '424628819532',
  appId: '1:424628819532:web:f99a6863786fefb171c6e9',
  measurementId: 'G-NPZXEM7GMZ',
};

export const EVENT_NAMES = {
  inapp_subscription_page_opened: 'inapp_subscription_page_opened',
  inapp_govip_button_clicked: 'inapp_govip_button_clicked',
  limitedtimeoffer_claimed: 'limitedtimeoffer_claimed',
  limitedtimeoffer_seeplans_clicked: 'limitedtimeoffer_seeplans_clicked',
};

// could be singleton but do not see reason, for now I keep all static and with one initializer
export class LogService {
  static fireBaseAnalytics: Analytics;

  static amplitudeAnalytics: any;

  constructor() {
    LogService.fireBaseAnalytics = getAnalytics(this.getApp());
    amplitude.getInstance().init(process.env.REACT_APP_AMPLITUDE_API_KEY, null);
  }

  init(force = false): void {
    if (!LogService.fireBaseAnalytics || force) {
      LogService.fireBaseAnalytics = getAnalytics(this.getApp());
    }
    if (!amplitude.getInstance()?.pageHandlersAdded || force) {
      amplitude.getInstance().init(process.env.REACT_APP_AMPLITUDE_API_KEY, null);
    }
  }

  // eslint-disable-next-line class-methods-use-this
  private getApp(): FirebaseApp {
    return initializeApp(firebaseConfig);
  }

  public static handleEvent(eventName: string, additionalParams = {}): void {
    if (isProd()) {
      const date = new Date();
      const data = { createdAt: date.toUTCString(), ...additionalParams };

      // firebase
      logEvent(LogService.fireBaseAnalytics, eventName, data);

      // amplitude
      if (amplitude.getInstance()?.pageHandlersAdded) {
        amplitude.getInstance().logEvent(eventName, data);
      }
    }
  }

  public static pageOpened(
    os: string | null,
    country: string | null,
    variation: string | null,
    subscriber_id: string | null
  ): void {
    LogService.handleEvent(EVENT_NAMES.inapp_subscription_page_opened, {
      os: os?.toLowerCase() || '',
      country: country?.toLowerCase() || '',
      variation: variation?.toLowerCase() || '',
      subscriber_id: subscriber_id?.toLowerCase() || '',
    });
  }

  public static subscribeButtonClicked(
    plan: string | null,
    payment_method: string | null,
    variation: string | null,
    subscriber_id: string | null
  ): void {
    LogService.handleEvent(EVENT_NAMES.inapp_govip_button_clicked, {
      plan: plan?.toLowerCase() || '',
      payment_method: payment_method?.toLowerCase() || '',
      variation: variation?.toLowerCase() || '',
      subscriber_id: subscriber_id?.toLowerCase() || '',
    });
  }

  public static activateLimitedTimeOfferV2ButtonClicked(
    plan: string | null,
    payment_method: string | null,
    variation: string | null,
    subscriber_id: string | null
  ): void {
    LogService.handleEvent(EVENT_NAMES.limitedtimeoffer_claimed, {
      plan: plan?.toLowerCase() || '',
      payment_method: payment_method?.toLowerCase() || '',
      variation: variation?.toLowerCase() || '',
      subscriber_id: subscriber_id?.toLowerCase() || '',
    });
  }

  public static seeOtherPlansLimitedTimeOfferV2ButtonClicked(
    plan: string | null,
    payment_method: string | null,
    variation: string | null,
    subscriber_id: string | null
  ): void {
    LogService.handleEvent(EVENT_NAMES.limitedtimeoffer_seeplans_clicked, {
      plan: plan?.toLowerCase() || '',
      payment_method: payment_method?.toLowerCase() || '',
      variation: variation?.toLowerCase() || '',
      subscriber_id: subscriber_id?.toLowerCase() || '',
    });
  }
}
